import { APP_INITIALIZER, InjectionToken, LOCALE_ID, ModuleWithProviders, NgModule } from '@angular/core';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { registerLocaleData } from '@angular/common';
import { Observable, of } from 'rxjs';
import localeDeCH from '@angular/common/locales/de-CH';

function initLanguage(translate: TranslateService) {
  let language = navigator.language.substr(0, 2)
  if (['de', 'en', 'it', 'fr'].indexOf(language) >= 0) {
    console.log('detected language', language)
    translate.use(language);
  }
}

function getLoader(assetFn: (lang: string) => any) {
  const loader: TranslateLoader = {
    getTranslation(lang: string): Observable<any> {
      const result = assetFn(lang)
      return of(result);
    }
  }


  return loader;
}

const LANGUAGE_ASSET_DIRECTORY = new InjectionToken<(lang: string) => any>('language.asset.dir')

registerLocaleData(localeDeCH);

@NgModule({
  declarations: [],
  exports: [TranslateModule],
  imports: [
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: (dir: (lang: string) => any) => getLoader(dir),
        deps: [LANGUAGE_ASSET_DIRECTORY]
      }
    }),
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'de-CH' },
    {
      provide: APP_INITIALIZER,
      useFactory: (translate: TranslateService) => () => initLanguage(translate),
      deps: [TranslateService],
      multi: true,
    },
  ]
})
export class TranslationModule {
  static forRoot(options: {assetFn: (lang: string) => any}): ModuleWithProviders<TranslationModule> {
    return {
      ngModule: TranslationModule,
      providers: [
        {
          provide: LANGUAGE_ASSET_DIRECTORY,
          useValue: options.assetFn,
        }
      ]
    }
  }
}
